module.exports = __webpack_public_path__ + "static/media/ic_carDisabled.3393cd25.svg";